import React, { Component } from 'react'
import { View, Platform } from 'react-native'
import { connect } from 'react-redux';
import { LocationIcon, HomeIcon, HomeOutlineIcon } from '../../ui/components/Icons';
import { moderateScale } from 'react-native-size-matters';
import { styles } from '../steps/Styles';
import { GymTypes } from 'fitbeat.models';
import theme from '../../theme';
import { GymResolver } from '../../services';
import { isOfficeScheduleBookingSelector } from '../selectors';

class BookingLocationIcon extends Component {
    render() {
        const size = 16;
        const { isOfficeScheduleBooking } = this.props;
        const gym = GymResolver.getByName(this.props.currentSelectedGymName);
        return (
            <View style={styles.locationIconStyle}>
                {(gym.type === GymTypes.Home && !isOfficeScheduleBooking) ?
                    <HomeOutlineIcon
                        size={size}
                        color={theme.GREY_MEDIUM_LIGHT}
                        styles={{ marginHorizontal: 5 }}
                    /> :
                    <LocationIcon
                        size={moderateScale(20, 1)}
                        color={theme.GREY_MEDIUM_LIGHT}
                    />}
            </View>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentSelectedGymName: state.bookings.bookingWizard.currentSelectedGymName,
        isOfficeScheduleBooking: isOfficeScheduleBookingSelector(state),
    };
}

BookingLocationIcon = connect(mapStateToProps, null)(BookingLocationIcon);
export default BookingLocationIcon;
